import { Component, ReactNode } from "react";
import st from "./ErrorBoundary.module.scss";

interface IErrorBoundaryProps {
	children: ReactNode;
};

interface IErrorBoundaryState {
	error: any;
	errorInfo: any;
	redirectUrl: string;
};

class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {
	
	constructor( props: IErrorBoundaryProps ) {
		super(props);
		this.state = { error: null, errorInfo: null, redirectUrl: "" };
	};
	
	componentDidCatch( error: any, errorInfo: any ) {
		const url = window.location.href;
		let redir = "";
		const index = url.indexOf( 'portal/file/' );
		if ( index !== -1 ) {
			const id = window.location.href.substring( index + 12 );
			redir = window.host + "/WebInterfaceModule/File?fileId=" + id;
		}
		this.setState({
			error: error,
			errorInfo: errorInfo,
			redirectUrl: redir
	  	});
	};

	redirectClickHandler = () => window.location.href = this.state.redirectUrl;
	
	renderError = () => {
		if ( this.state.errorInfo ) {
			return (
				<div className={st.error_wrapper}>
					<div className={st.error_scroll_wr}>
						<div className={st.error_block}>
							<div className={st.error_header}>
								<h2>Произошла ошибка клиентской части приложения :(</h2>
								<button onClick={() => this.setState({ error: null, errorInfo: null })}>X</button>
							</div>
							{ 
								this.state.error && 
								<h3 className={st.error}> 
									<span>{ this.state.error.message }</span>
									{ this.state.redirectUrl && <button onClick={this.redirectClickHandler}>Открыть в старом интерфейсе</button> }
								</h3> 
							}
							<details style={{ whiteSpace: 'pre-wrap' }}>
								{ this.state.error && this.state.error.message }
								{ this.state.errorInfo.componentStack }
							</details>
						</div>
					</div>
				</div>
			);
		}
		else 
			return null;
	};

	render = () => (
		<>
			{ this.props.children }
			{ this.renderError() }
		</>
	);
};

export default ErrorBoundary;
